import {FC, useLayoutEffect, useRef, useState} from 'react'
import {sanitizeHtml} from './sanitizeHtml'

const ExpandableDescription: FC<{text?: string; html?: boolean}> = ({text, html}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isTruncatable, setIsTruncatable] = useState(false)
  const textRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const el = textRef.current
    if (!el || isExpanded) return
    const checkOverflow = () => setIsTruncatable(el.scrollHeight > el.clientHeight)
    checkOverflow()
    const observer = new ResizeObserver(checkOverflow)
    observer.observe(el)
    return () => observer.disconnect()
  }, [text, isExpanded])

  const truncateClass = isExpanded ? '' : 'truncated-3-line'

  return (
    <>
      {html ? (
        <div ref={textRef} className={truncateClass} style={{ minWidth: '0', wordBreak: 'break-word' }} dangerouslySetInnerHTML={{__html: sanitizeHtml(text)}} />
      ) : (
        <p ref={textRef} className={truncateClass}>{text || ''}</p>
      )}
      {isTruncatable && (
        <div className='readmore-300 w-100 fs-9' onClick={() => setIsExpanded((prev) => !prev)}>
          {isExpanded ? 'Read less' : 'Read more'}
        </div>
      )}
    </>
  )
}

export {ExpandableDescription}